import { useQuery } from '@tanstack/react-query'
import { notificationsApi } from '../api/notificationsApi'

export const useUnreadCount = () => {
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: notificationsApi.getUnreadCount,
    staleTime: Infinity,
  })
}
